import { useRef, useState, useEffect } from "react";
import { Typography } from "@mui/material";
import CustomTooltip from "./CustomTooltip";

const OverflowTooltip = ({
  children,
  sx = {},
  variant = null,
  placement = "top",
  onClick = () => null,
}) => {
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  // Is the text cut off ("...")? Checked when it changes and on every hover,
  // so a text cut off later (e.g. a narrower window) still gets its tooltip
  const checkOverflow = () => {
    const el = textRef.current;
    if (el) setShowTooltip(el.scrollWidth > el.clientWidth);
  };

  useEffect(checkOverflow, [children]);

  return (
    <CustomTooltip
      placement={placement}
      title={showTooltip ? (typeof children === "string" ? children : "") : ""}
    >
      <Typography
        ref={textRef}
        onMouseEnter={checkOverflow}
        onClick={onClick}
        variant={variant}
        sx={(theme) => ({
          ...theme.mixins.overflow,
          //   display: "-webkit-box",
          //   WebkitLineClamp: lines, // number of lines to show
          //   WebkitBoxOrient: "vertical",
          //   overflow: "hidden",
          //   textOverflow: "ellipsis",
          cursor: showTooltip ? "pointer" : "inherit",
          maxWidth: "100%", // dynamic width (fit parent)
          ...sx,
        })}
      >
        {children}
      </Typography>
    </CustomTooltip>
  );
};

export default OverflowTooltip;
